import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input, Select, Form, Upload, Image } from "antd";
import toast from 'react-hot-toast';
import { SendMarketingEmailApi } from '../../../api/request/emailMarketing';
import LoadableButton from '../../../components/buttons/LoadableButton';
import HTMLEditor from '../../../components/global/htmlEditor/HTMLEditor';
import { GetAllUsersApi } from '../../../api/request/settings/notifications';

const AddEmail = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const [fileList, setFileList] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [allUsers, setAllUsers] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const emailEditorRef = useRef(null);

    const filteredOptions = allUsers?.filter(option => !selectedUsers.map(item => item.value).includes(option.value));

    const getBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
        form.setFieldsValue({ UploadImage: newFileList });
        if (newFileList?.length == 0) {
            form.setFieldsValue({ UploadImage: [] });
        }
    }

    const handleChangeOption = (values) => {
        setSelectedUsers(values.map(value => allUsers.find(option => option.value === value)))
    };

    const filterOption = (input, option) => {
        return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
    };

    const tagRender = (props) => {
        const { value, closable, onClose } = props;
        const option = allUsers.find(opt => opt.value === value);
        return (
            <span className="inline-flex items-center px-2 py-[1px] rounded-sm mr-1 my-1 bg-primary-light">
                {option?.label}
                {closable && (<span onClick={onClose} className="cursor-pointer ml-2">x</span>)}
            </span>
        );
    };

    const fetchUsers = async () => {
        try {
            let params = {
                ApplyPagination: false
            }
            const { data } = await GetAllUsersApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setAllUsers(data?.data?.map((item) => { return { value: item?.userId, label: `${item?.firstName} ${item?.lastName}` }; }));
            }
        } catch (err) { }
    }

    const UploadButton = (
        <button type="button">
            <div className="flex justify-center"><img src="/assets/icons/Upload_Document_icon.svg" alt="icon" /></div>
            Upload
        </button>
    );

    const getHtml = async (values) => {
        setIsLoading(true)
        await emailEditorRef?.current?.editor?.exportHtml((data) => {
            const { html } = data;
            handleSubmit(values, html)
        });
    }

    const handleSubmit = async (values, html) => {
        try {
            const formData = new FormData();
            formData.append("Subject", values?.Subject);
            const users = selectedUsers.map(item => item.value);
            users.map((item, index) => { formData.append(`UserId[${index}]`, item); })
            formData.append("Body", html);
            fileList.forEach((file) => { formData.append("Attachment", file.originFileObj); });
            const { data } = await SendMarketingEmailApi(formData)
            if (data?.success) {
                navigate("/email_marketing")
                toast.success(data?.message)
            }
            setIsLoading(false)
        }
        catch (error) {
            toast.error(error?.response?.data?.message)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchUsers();
    }, [])

    return (
        <div className='border-2 border-light rounded-xl p-4'>
            <Form className='w-full' autoComplete="off" form={form} onFinish={getHtml}>
                <div className="grid sm:grid-cols-2 gap-5 ">
                    <div className='ant-select-selector-white ant-multi-select-selector mt-1'>
                        <label className='text-base text-[#2F2B3DCC] font-medium mb-0.5 mt'>Users</label>
                        <Form.Item name="userId" rules={[{ required: true, message: 'Please select user.' }]}>
                            <Select mode="multiple" className='p-0' placeholder="By default it will notify all users." value={selectedUsers.map(item => item.value)} onChange={handleChangeOption} options={filteredOptions} tagRender={tagRender} filterOption={filterOption} />
                        </Form.Item>
                    </div>
                    <div className='input-white'>
                        <label className='text-base text-[#2F2B3DCC] font-medium mb-0.5'>Subject</label>
                        <Form.Item name="Subject" rules={[{ required: true, message: 'Please enter email subject.' }]}>
                            <Input placeholder="Email subject" className="mt-1 ps-4 py-2" />
                        </Form.Item>
                    </div>
                </div>
                <div className="mt-2">
                    <label className='text-base text-[#2F2B3DCC] font-medium mb-0.5'>Body</label>
                    <HTMLEditor emailEditorRef={emailEditorRef} />
                </div>

                <div className="mt-2">
                    <label className="text-base text-[#2F2B3DCC] font-medium">Attchment</label>
                    <Form.Item name="Upload Attchment">
                        <Upload
                            beforeUpload={() => false}
                            listType="picture-card"
                            className="mt-1"
                            fileList={fileList}
                            onPreview={handlePreview}
                            onChange={handleChange}
                        >
                            {fileList.length >= 1 ? null : UploadButton}
                        </Upload>
                    </Form.Item>
                    {previewImage && (
                        <Image
                            wrapperStyle={{ display: 'none' }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(''),
                            }}
                            src={previewImage}
                        />
                    )}
                </div>
                <div className='flex justify-end items-center gap-5 mt-6'>
                    <LoadableButton
                        className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500'
                        disabled={isLoading}
                        type="Submit"
                        lable='Submit'
                        isLoading={isLoading}
                        loadingLable='Adding email...'
                    />
                </div>
            </Form>
        </div>
    )
}

export default AddEmail